import { render, staticRenderFns } from "./insurancePolicy.vue?vue&type=template&id=b33292aa&scoped=true&"
import script from "./insurancePolicy.vue?vue&type=script&lang=js&"
export * from "./insurancePolicy.vue?vue&type=script&lang=js&"
import style0 from "./insurancePolicy.vue?vue&type=style&index=0&id=b33292aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33292aa",
  null
  
)

export default component.exports